import React from "react";

const ListOfLiabilities = ({ listOfLiabilities }) => {
  return (
    <div className="ListOfLiabilitiesContainer">
      <ul
        style={{
          listStyle: "none",
        }}
        className="ListOfLiabilities"
      >
        <li
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
          }}
          className="titleContainer color-grayBorder text-align-center mb-1"
        >
          <div className="text-align-left">Liability</div>
          <div>Process slots</div>
          <div>Time to pay</div>
          <div>Value(INR)</div>
        </li>
        <div className="scroll-y" style={{ maxHeight: "300px" }}>
          {listOfLiabilities.map((liability) => (
            <li
              key={liability.id}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr 1fr",
                paddingTop: "1rem",
              }}
              className="listItem text-align-center underline-border p-b-1 t-14 color-deepGreen3"
            >
              <div className="text-align-left t-16 color-grayColor">
                {liability.title}
              </div>
              <div>{liability.processSlots}</div>
              <div>{liability.timeToPay}</div>
              <div>{liability.value}</div>
            </li>
          ))}
        </div>
      </ul>
    </div>
  );
};

export default ListOfLiabilities;
